declare global {
  interface Window {
    __timeOffset?: number;
  }
}

export const setTimeOffset = (offset: number) => {
  if (typeof window !== "undefined") {
    window.__timeOffset = offset;
  }
};

export const getTimeOffset = () => {
  if (typeof window !== "undefined") {
    return window.__timeOffset ?? 0;
  }
  return 0;
};
